import { ReportsComponent } from "./reports.component";
import { LinescoresComponent } from "./linescores/linescores.component";
import {
  RatingsGuard,
  OtherGuard,
  VerbatimsGuard,
  BrandsTabGuard,
  DriverGuard,
  LinescoreDataGuard,
  ReportTypeGuard,
} from "./guards";
import { LinescoreTabComponent } from "./linescore-tab/linescore-tab.component";
import { ReportCacheGuard } from "./guards/report-cache.guard";
import { NotFoundComponent, Auth2Guard, AuthService } from "core";
import { SimpleComponent } from "./simple/simple.component";
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";
import { Store } from "@ngrx/store";
import { ReportsState } from "./store";
import { catchError, filter, from, map, of, switchMap, take, tap } from "rxjs";
import { getCache, getCacheLoaded } from './store/selectors/cache.selectors';
import { StoryBlok, reducerMap } from "core/components/storyblok";
import { Auth, idToken, signInWithCustomToken, user } from "@angular/fire/auth";
import { AuthGuard, redirectUnauthorizedTo } from "@angular/fire/auth-guard";
import { LandingPage } from "./landing.component";

const getManual = () => inject(HttpClient).get<StoryBlok>('https://api-us.storyblok.com/v2/cdn/stories/full?version=draft&token=J5FmSu5Jaj7iFY6Yj5692wtt&cv=1690044091')
  .pipe(map(result => {
    // console.log(result.story);
    
    const bloks = result.story.content.body;
    const blokMap = bloks.reduce(reducerMap, {});

    // console.log(blokMap);
    return blokMap;
  }))

export const appRoutes: Route[] = [
  {
    path: ":cacheKey",
    canActivate: [
      (route: ActivatedRouteSnapshot) => {
        const authServ = inject(AuthService);
        const fbAuth = inject(Auth);
        return user(fbAuth).pipe(
          take(1),
          switchMap(user => {
            if (user)
              return of(true);
            else {
              if (authServ.token) {
                return authServ.getFirebaseToken().pipe(
                  switchMap(result => from(signInWithCustomToken(fbAuth, result.token))),
                  map(() => true),
                  catchError(err => {
                    console.error(err);
                    return of(false);
                  })
                );
              }
              return of(true);
            }
          })
        );
      },
      AuthGuard, Auth2Guard
    ],
    component: ReportsComponent,
    // resolve: {
    //   manual: getManual
    // },
    data: {
      authGuardPipe: (stuff: ActivatedRouteSnapshot, other: RouterStateSnapshot) => {
        sessionStorage.setItem('redirectUrl', other.url);
        return redirectUnauthorizedTo('login');
      }
    },
    children: [
      {
        path: "",
        canActivate: [
          ReportCacheGuard,
          ReportTypeGuard,
        ],
        canActivateChild: [ReportTypeGuard],
        resolve: {
          cell: (routeSnap: ActivatedRouteSnapshot) => {
            const store = inject(Store<ReportsState>),
              http = inject(HttpClient);
            return store.select(getCacheLoaded).pipe(
              filter(loaded => loaded),
              take(1),
              switchMap(() => store.select(getCache).pipe(take(1))),
              switchMap(rCache => http.get(`${environment.apiUrl}/survey/${rCache.cell_id}`))
            );
          },
        },
        children: [
          {
            path: "linescore",
            data: {
              title: "Linescore",
              name: "linescore",
            },
            canActivate: [LinescoreDataGuard],
            component: LinescoreTabComponent,
          },
          {
            path: "driver",
            canActivate: [DriverGuard],
            data: {
              title: "Driver Analysis",
              name: "driver",
            },
            loadComponent: () => import('./driver-tab/driver-tab.component'),
          },
          {
            path: "brands",
            data: {
              title: "Competitive Benchmarks",
              name: "brands",
            },
            canActivate: [BrandsTabGuard],
            loadComponent: () => import('./brands-tab/brands-tab.component'),
          },
          {
            path: "individuals",
            canActivate: [VerbatimsGuard],
            loadComponent: () => import('./individuals/individuals.component'),
          },
          {
            path: "other",
            data: {
              name: "other",
              title: "Other Tables",
            },
            canActivate: [OtherGuard],
            loadComponent: () => import('./tables-tab/tables-tab.component')
          },
          {
            path: "ratings",
            data: {
              name: "ratings",
            },
            canActivate: [RatingsGuard],
            loadComponent: () => import('./ratings/ratings.component')
          },
          // {
          //     path: 'slides',
          //     data: {
          //         title: 'Export to Slides'
          //     },
          //     component: SlidesComponent
          //     // component: SlidesExportComponent
          // },
          {
            path: "linescores",
            component: LinescoresComponent,
          },
          {
            path: "summary",
            component: SimpleComponent,
          },
          {
            path: 'vw',
            loadChildren: () => import('./vw/vw.routing')
          }
        ],
      },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    component: LandingPage
  },
  {
    path: "**",
    component: NotFoundComponent,
  },
];

export default appRoutes;